import React from "react";
import ReportProfileTableHeader from "./ReportProfileTableHeader";
import ReportProfileTableBody from "./ReportProfileTableBody";

interface ReportProfile {
  reportId: number;
  code: string;
  name: string;
  enabled: boolean;
}

interface ReportProfileTableProps {
  reports: ReportProfile[];
  onToggle: (report: ReportProfile) => void; // ✅ ahora recibe el objeto completo
}

/**
 * 📊 Tabla modular de reportes por perfil
 *
 * - Misma base visual que AdvancedRecordTable
 * - Bordes, sombras y fondos unificados
 * - Adaptable al modo oscuro
 */
const ReportProfileTable: React.FC<ReportProfileTableProps> = ({
  reports,
  onToggle,
}) => {
  return (
    <section className="data-table-common data-table-two mt-6 border-b border-t border-stroke bg-white py-4 shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="w-full overflow-x-auto p-2">
        <table className="datatable-table w-full min-w-[700px] table-auto border-collapse break-words md:table-fixed md:overflow-auto">
          <ReportProfileTableHeader />
          <ReportProfileTableBody reports={reports} onToggle={onToggle} />
        </table>
      </div>
    </section>
  );
};

export default ReportProfileTable;
